"use strict";

var _clientAuth = require("@devsta/client-auth");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = isUserAnonymousOrAuthFalsy;

function isUserAnonymousOrAuthFalsy() {
  var _credentials$get = _clientAuth.credentials.get(),
      auth = _credentials$get.auth,
      user = _credentials$get.user,
      isAnonymous = (user || {}).isAnonymous;

  return !(auth && !isAnonymous);
}